<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <div class="user-box" v-bind="attrs" v-on="on">
        <v-icon class="user-avatar" color="#ccc" v-bind="attrs" v-on="on"> account_circle </v-icon>
        <div class="user-details">
          <label class="user-name">{{ username }}</label>
          <span class="user-type">{{ userType }}</span>
        </div>
      </div>
    </template>

    <v-list dense class="user-panel">
      <v-list-item-group color="primary">
        <v-list-item class="d-none">
          <v-list-item-icon>
            <Icon :path="require('@/assets/navbar/config.svg')" :width="14" :height="13" />
          </v-list-item-icon>
          <v-list-item-content class="dark--text">
            <v-list-item-title v-text="this.$t('menu.account_settings')"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="logout">
          <v-list-item-icon>
            <Icon :path="require('@/assets/navbar/exit.svg')" :width="14" :height="13" />
          </v-list-item-icon>
          <v-list-item-content class="error--text">
            <v-list-item-title v-text="$t('menu.logout')"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script>
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import "../styles.scss";

const NavMenu = Vue.extend({
  name: "NavMenu",

  props: {
    username: {
      type: String,
    },
    userType: {
      type: String,
    },
  },
  methods: {
    ...mapActions({
      doLogout: "User/doLogOut",
      OOCDoLogout: "OOCUsers/oocDoLogOut",
    }),

    /**
     * Handle logout
     * @return {void}
     */
    async logout() {
      await this.doLogout();
      await this.OOCDoLogout();
      await this.$router.push("/login");
    },
  },
});
export default NavMenu;
</script>
